import { QueryEmitter } from "./query.emiter";
import { QueryBuilderService } from "../data/query.builder";
import { ValueAdapterProvider } from "../data/value.adapter.provider";
import { KeywordToResourceResolver } from "../data/keyword.to.resource.resolver";
import { QueryExpressionParserService } from "../query.expression.parser/query.expression.parser.service";
import { StrictSqlWhereParserService } from "@nrwl/query-emitter";

/**
 * A convenience class to wrap multiple services, provided by query-emitter
 * (or implementing) modules.
 */
export abstract class QueryEmitterServicesProvider {
  abstract getDataSource(): QueryEmitter;
  abstract getBuilder(): QueryBuilderService;
  abstract getValueAdapter(): ValueAdapterProvider;
  abstract getResolver(): KeywordToResourceResolver;
  abstract getParser(): QueryExpressionParserService;
  abstract getExpParser(): StrictSqlWhereParserService;
}
